// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/remover
 *
 * Deletes a product by ID.
 */
import { registerContract } from './validate'

export interface Products_RemoverInput {
so_product_id: number
}

registerContract('Products_RemoverInput', {
  so_product_id: { type: 'number',  required: true },
})
